// extracted by mini-css-extract-plugin
module.exports = {"blockClick":"SendersDomainList_blockClick_2WbLn"};